import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  AddAlert,
  Button,
  IEvent,
  Input,
  IRadioButtonEvent,
  Modal,
  RadioButton,
} from '../../../../component';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { modalOpen } from '../../redux/dashboardActions';
import { IdNamePair } from '../../types';
import nls from '../nls/pt-BR.json';
import { patchStudy } from '../redux/studies.controller';
import { studiesSelector } from '../redux/studies.reducer';
import { useStudiesList } from '../useStudiesList';

export const EditStudyModal: React.FC = () => {
  const OPTIONS: IdNamePair[] = [
    { id: 'shared', name: nls.modal.shared },
    { id: 'private', name: nls.modal.private },
  ];
  const MAX_LENGTH = 30;
  const { statusModal } = useTypedSelector((state) => state.dashboardState);
  const { selectedStudy, pagination, titleSearchInput } =
    useTypedSelector(studiesSelector);
  const [name, setName] = useState<string>(
    selectedStudy ? selectedStudy.name : ''
  );
  const [checked, setChecked] = useState<IdNamePair>(
    selectedStudy?.is_public ? OPTIONS[0] : OPTIONS[1]
  );
  const dispatch = useDispatch();
  const handleChangeInput = (e: IEvent) => {
    setName(e.value.slice(0, MAX_LENGTH));
  };
  const handleChangeRadioButton = (e: IRadioButtonEvent) => {
    setChecked({ ...e.value });
  };
  const { getList } = useStudiesList();
  const handleClickEdit = async () => {
    try {
      dispatch([loading(), modalOpen('')]);
      const payload = {
        name,
        is_public: checked.id === 'shared',
      };
      await patchStudy(payload, selectedStudy?.id ?? '');
      await getList(pagination.currentPage.toString(), titleSearchInput);
      dispatch([AddAlert('success', 'Estudo editado com sucesso')]);
    } catch (e) {
      dispatch(AddAlert('warning', 'Erro ao editar estudo'));
    } finally {
      dispatch(loaded());
    }
  };
  return (
    <Modal
      open={statusModal === 'edit study modal'}
      close={() => dispatch(modalOpen(''))}
      title={nls.modal.editReport}
      cy="EditStudy"
      actions={
        <>
          <Button
            cy="EditStudy"
            className="btn normal primary"
            onClick={handleClickEdit}
          >
            {nls.modal.save}
          </Button>
        </>
      }
    >
      <div>
        <Input
          label={nls.modal.name}
          placeholder={nls.modal.placeholder}
          cy="EditStudyName"
          value={name}
          action={handleChangeInput}
          style={{
            backgroundColor: '#FFF',
            color: '#000',
            border: '1px solid #383939',
            borderRadius: 4,
          }}
        />
        <span style={{ float: 'right' }}>
          {name.length}/{MAX_LENGTH}
        </span>
      </div>
      <RadioButton
        options={OPTIONS}
        checked={checked}
        action={handleChangeRadioButton}
        label={nls.modal.type}
        name={nls.modal.type}
        cy="EditStudy"
      />
    </Modal>
  );
};
